// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


.navbar-custom {
  background-color: #ececf1;
  border-radius: 0;
  margin-bottom: 0;
  padding: 0 10px 0 0;
  margin-left: 240px;
  min-height: 70px;
}

.topbar {
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;
}

.topbar .topbar-left {
  background: #1893d6;
  float: left;
  text-align: center;
  height: 70px;
  position: relative;
  width: 240px;
  z-index: 1;
}


.content-page{
  width: 100%;
  padding-top: 150px;
  background: #f8f8fa;
  min-height: 100vh;
}

.tab {
  min-height: 50px;
  min-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;border-color: #dcdcdc #dcdcdc white;
  text-align: center;
  font-size: 1.2rem;
  color: black;
  margin-right: 2px
}


.opcao_autocomplete{
  padding: 10px 10px 10px 10px;
  background-color: white;
  cursor: pointer;

}
.opcao_autocomplete:hover{
  background-color: #f2f2f2;
}

.col-form-label{
  margin-top: 10px;
  font-weight: bold;
  padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5;
}

.header-title{
  font-weight: bold;
}

.map2{
  position: relative !important;
  height: 100%;
}

.hr_show{
  display: block;
}


@media (max-width:992px){
  .hr_show{
    display: none;
  }
}


@media (max-width:576px){
  .hr_show{
    display: block;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/private/Dashboard/SideBar/styles/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,QAAQ;EACR,MAAM;EACN,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB,CAAC,mCAAmC;EACvD,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ;AACF;;;AAGA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;;AAEjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;IAC/B,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE;IACE,aAAa;EACf;AACF;;;AAGA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n.navbar-custom {\n  background-color: #ececf1;\n  border-radius: 0;\n  margin-bottom: 0;\n  padding: 0 10px 0 0;\n  margin-left: 240px;\n  min-height: 70px;\n}\n\n.topbar {\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 999;\n}\n\n.topbar .topbar-left {\n  background: #1893d6;\n  float: left;\n  text-align: center;\n  height: 70px;\n  position: relative;\n  width: 240px;\n  z-index: 1;\n}\n\n\n.content-page{\n  width: 100%;\n  padding-top: 150px;\n  background: #f8f8fa;\n  min-height: 100vh;\n}\n\n.tab {\n  min-height: 50px;\n  min-width: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;border-color: #dcdcdc #dcdcdc white;\n  text-align: center;\n  font-size: 1.2rem;\n  color: black;\n  margin-right: 2px\n}\n\n\n.opcao_autocomplete{\n  padding: 10px 10px 10px 10px;\n  background-color: white;\n  cursor: pointer;\n\n}\n.opcao_autocomplete:hover{\n  background-color: #f2f2f2;\n}\n\n.col-form-label{\n  margin-top: 10px;\n  font-weight: bold;\n  padding-top: calc(0.375rem + 1px);\n    padding-bottom: calc(0.375rem + 1px);\n    margin-bottom: 0;\n    font-size: inherit;\n    line-height: 1.5;\n}\n\n.header-title{\n  font-weight: bold;\n}\n\n.map2{\n  position: relative !important;\n  height: 100%;\n}\n\n.hr_show{\n  display: block;\n}\n\n\n@media (max-width:992px){\n  .hr_show{\n    display: none;\n  }\n}\n\n\n@media (max-width:576px){\n  .hr_show{\n    display: block;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
